// extracted by mini-css-extract-plugin
export default {"container":"EditClinicScreen_container__e-gyj"};